import script from "./clientitem.vue?vue&type=script&setup=true&lang=js"
export * from "./clientitem.vue?vue&type=script&setup=true&lang=js"

import "./clientitem.vue?vue&type=style&index=0&id=38ead170&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ead170"]])

export default __exports__